import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const StakeholderInfoPanel = ({ project }) => {
  const stakeholders = [
    {
      id: 1,
      name: 'María Fernández',
      role: 'Coordinadora de Proyecto',
      organization: 'EcoForest Solutions',
      email: 'maria.fernandez@ecoforest.com',
      phone: '+52 55 1234 5678',
      avatar: 'https://randomuser.me/api/portraits/women/44.jpg',
      avatarAlt: 'Professional headshot of Hispanic woman with long dark hair in green blazer',
      status: 'activo'
    },
    {
      id: 2,
      name: 'Carlos Mendoza',
      role: 'Especialista MRV',
      organization: 'Carbon Analytics Lab',
      email: 'carlos.mendoza@carbonlab.com',
      phone: '+52 55 2345 6789',
      avatar: 'https://randomuser.me/api/portraits/men/52.jpg',
      avatarAlt: 'Professional headshot of Hispanic man with short black hair in navy suit',
      status: 'activo'
    },
    {
      id: 3,
      name: 'Ana Rodríguez',
      role: 'Analista Geoespacial',
      organization: 'GeoCarbon Institute',
      email: 'ana.rodriguez@geocarbon.org',
      phone: '+52 55 3456 7890',
      avatar: 'https://randomuser.me/api/portraits/women/68.jpg',
      avatarAlt: 'Professional headshot of Hispanic woman with shoulder-length brown hair in white blouse',
      status: 'activo'
    },
    {
      id: 4,
      name: 'Jorge Silva',
      role: 'Auditor de Validación',
      organization: 'Verra Certification',
      email: 'jorge.silva@verra.org',
      phone: '+1 202 555 0123',
      avatar: 'https://randomuser.me/api/portraits/men/75.jpg',
      avatarAlt: 'Professional headshot of Hispanic man with glasses and gray hair in formal suit',
      status: 'consultor'
    }
  ];

  const communityPartners = [
    {
      id: 1,
      name: 'Comunidad Indígena Xochimilco',
      type: 'Comunidad Local',
      members: 450,
      area: '2,340 ha',
      icon: 'Users',
      color: 'var(--color-primary)'
    },
    {
      id: 2,
      name: 'Cooperativa Forestal del Sur',
      type: 'Organización Productiva',
      members: 120,
      area: '1,850 ha',
      icon: 'TreePine',
      color: 'var(--color-accent)'
    },
    {
      id: 3,
      name: 'Asociación de Ganaderos Sostenibles',
      type: 'Sector Ganadero',
      members: 85,
      area: '3,200 ha',
      icon: 'Beef',
      color: 'var(--color-success)'
    }
  ];

  return (
    <div className="space-y-6">
      <div className="card">
        <div className="flex items-center gap-3 mb-6">
          <div className="flex items-center justify-center w-10 h-10 bg-primary/10 rounded-lg">
            <Icon name="Users" size={20} color="var(--color-primary)" />
          </div>
          <h2 className="text-xl font-semibold font-mono">Equipo del Proyecto</h2>
        </div>

        <div className="space-y-4">
          {stakeholders?.map((stakeholder) => (
            <div
              key={stakeholder?.id}
              className="p-4 bg-background rounded-lg border border-border hover:border-primary/20 hover:shadow-md transition-all duration-250"
            >
              <div className="flex items-start gap-4">
                <Image
                  src={stakeholder?.avatar}
                  alt={stakeholder?.avatarAlt}
                  className="w-12 h-12 rounded-full object-cover flex-shrink-0"
                />

                <div className="flex-1 min-w-0">
                  <div className="flex items-start justify-between gap-2 mb-2">
                    <div>
                      <h3 className="text-sm font-medium text-foreground">{stakeholder?.name}</h3>
                      <p className="text-xs text-muted-foreground caption">{stakeholder?.role}</p>
                    </div>
                    <span
                      className={`px-2 py-1 text-xs rounded caption font-medium flex-shrink-0 ${
                        stakeholder?.status === 'activo' ?'bg-success/10 text-success' :'bg-muted text-muted-foreground'
                      }`}
                    >
                      {stakeholder?.status === 'activo' ? 'Activo' : 'Consultor'}
                    </span>
                  </div>

                  <p className="text-xs text-muted-foreground caption mb-3">
                    {stakeholder?.organization}
                  </p>

                  <div className="flex flex-col gap-2">
                    <div className="flex items-center gap-2 text-xs text-muted-foreground caption">
                      <Icon name="Mail" size={14} />
                      <span className="truncate">{stakeholder?.email}</span>
                    </div>
                    <div className="flex items-center gap-2 text-xs text-muted-foreground caption">
                      <Icon name="Phone" size={14} />
                      <span>{stakeholder?.phone}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="card">
        <div className="flex items-center gap-3 mb-6">
          <div className="flex items-center justify-center w-10 h-10 bg-accent/10 rounded-lg">
            <Icon name="Handshake" size={20} color="var(--color-accent)" />
          </div>
          <h2 className="text-xl font-semibold font-mono">Socios Comunitarios</h2>
        </div>

        <div className="space-y-4">
          {communityPartners?.map((partner) => (
            <div
              key={partner?.id}
              className="p-4 bg-background rounded-lg border border-border hover:border-primary/20 transition-all duration-250"
            >
              <div className="flex items-start gap-4">
                <div
                  className="flex items-center justify-center w-12 h-12 rounded-lg flex-shrink-0"
                  style={{ backgroundColor: `${partner?.color}15` }}
                >
                  <Icon name={partner?.icon} size={24} color={partner?.color} />
                </div>

                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-medium text-foreground mb-1">{partner?.name}</h3>
                  <p className="text-xs text-muted-foreground caption mb-3">{partner?.type}</p>

                  <div className="flex items-center gap-4 text-xs text-muted-foreground caption">
                    <div className="flex items-center gap-1">
                      <Icon name="Users" size={14} />
                      <span>{partner?.members} miembros</span>
                    </div>
                    <div className="flex items-center gap-1">
                      <Icon name="Maximize2" size={14} />
                      <span>{partner?.area}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default StakeholderInfoPanel;